module.exports = __webpack_public_path__ + "img/icon-remove.659063d3.svg";